var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close-cart",on:{"click":function($event){return _vm.clickCloseCart()}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Close Cart")]),_c('span',{staticClass:"top"}),_c('span',{staticClass:"bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }